@if (parentHeroComponent) {
  <ng-container *ngTemplateOutlet="classificationsHeroSection"></ng-container>
}
@if (parentTechnicalInformationComponent) {
  <ng-container *ngTemplateOutlet="classificationsAndCategoriesTechnicalInformationSection"></ng-container>
}

<!--  classifications hero section -->
<ng-template #classificationsHeroSection>
  @if (hasClassification) {
  <div class="d-flex flex-column flex-sm-row flex-wrap udex-my-8 udex-me-12">
    @if (hasSapCertifications) {
    <div class="udex-py-8 udex-pe-12">
      <div class="text-blue-gray">
        {{ prepareCertificationName() }}
      </div>
      <button (click)="openModal(partnerCertificationModalConfig)" [attr.data-cy]="'partner-certification-btn'"
        class="btn btn-link p-0">
        @if (sapCertifications[0].image?.url) {
        <cx-media [container]="sapCertifications[0].image"
          alt="icon_sap_classification" class="icon udex-me-4 d-inline"></cx-media>
        }
        <span class="certification-inline">{{ sapCertifications[0].value }}</span>
      </button>

      <udex-modal [open]="partnerCertificationModalConfig.isActive"
        (close)="closeModal(partnerCertificationModalConfig)" (open)="centerModal()" class="col-6">
        <div slot="header" class="w-100 d-flex justify-content-between align-items-center">
          <h3 class="heading__regular--s">{{ prepareCertificationName() }}</h3>
          <udex-control-button icon="decline" size="Large" design="Tertiary" accessible-role="Button"
            (click)="closeModal(partnerCertificationModalConfig)">
          </udex-control-button>
        </div>
        <div class="d-flex justify-content-center udex-mb-20">
          @if (sapCertifications[0].image?.url) {
          <cx-media [container]="sapCertifications[0].image"
            alt="icon_sap_classification" class="in-modal-icon">
          </cx-media>
          }
        </div>
        <h2 class="heading__regular--xxs text-center udex-mb-20">{{ sapCertifications[0].value }}</h2>
        <p class="text-center udex-mb-20">{{ sapCertifications[0].description }}</p>
      </udex-modal>
    </div>
    }
    @if (hasSolutionTypes) {
    <div class="udex-py-8 udex-pe-12">
      <div class="text-blue-gray">
        {{ prepareSolutionTypesName(false) }}
      </div>
      @if (solutionTypes.length < 2) {
      <div class="d-flex">
        <span class="body--s text-black">{{ solutionTypes[0] }}</span>
      </div>
      }
      @if (solutionTypes.length > 1) {
      <button (click)="openModal(solutionTypesModalConfig)" class="btn btn-link p-0">
        <span>{{ solutionTypes.length }} {{ prepareSolutionTypesName(true) }}</span>
      </button>

      <udex-modal [open]="solutionTypesModalConfig.isActive" (close)="closeModal(solutionTypesModalConfig)"
        (open)="centerModal()"
        class="col-6">
        <div slot="header" class="w-100 d-flex justify-content-between align-items-center">
          <h3 class="heading__regular--s">{{ prepareSolutionTypesName(false) }}</h3>
          <udex-control-button icon="decline" size="Large" design="Tertiary" accessible-role="Button"
            (click)="closeModal(solutionTypesModalConfig)">
          </udex-control-button>
        </div>
        <table [attr.data-cy]="'solution-types-modal'">
          @for (item of solutionTypes; track item) {
          <tr>
            <td align="left" class="udex-pb-4">{{ item }}</td>
          </tr>
          }
        </table>
      </udex-modal>
      }
    </div>
    }
    @if (hasWorksWith) {
    <div class="udex-py-8 udex-pe-12">
      <div class="text-blue-gray">
        {{ prepareWorksWithName(false) }}
      </div>
      @if (worksWith.length < 2) {
      <div class="d-flex">
        <span class="body--s text-black">{{ worksWith[0] }}</span>
      </div>
      }
      @if (worksWith.length == 2) {
      <div class="d-flex">
        <span class="body--s text-black">{{ worksWith[0] }}, {{ worksWith[1] }}</span>
      </div>
      }
      @if (worksWith.length > 2) {
      <button (click)="openModal(worksWithModalConfig)" class="btn btn-link p-0">
        <span>{{ worksWith.length }} {{ prepareWorksWithName(true) }}</span>
      </button>

      <udex-modal [open]="worksWithModalConfig.isActive" [attr.data-cy]="'works-with'"
        (close)="closeModal(worksWithModalConfig)" (open)="centerModal()">
        <div slot="header" class="w-100 d-flex justify-content-between align-items-center">
          <h3 class="heading__regular--s">{{ prepareWorksWithName(false) }}</h3>
          <udex-control-button icon="decline" size="Large" design="Tertiary" accessible-role="Button"
            (click)="closeModal(worksWithModalConfig)">
          </udex-control-button>
        </div>
        @if (worksWithModalConfig.isActive) {
        <table [attr.data-cy]="'works-with-modal'">
          @for (item of worksWith; track item) {
          <tr>
            <td align="left" class="udex-pb-4">{{ item }}</td>
          </tr>
          }
        </table>
        }
      </udex-modal>
      }
    </div>
    }
  </div>
  }
</ng-template>

<!--  classifications technical information section -->
<ng-template #classificationsAndCategoriesTechnicalInformationSection>
  @if (hasGeneralTechnicalInformationSection) {
  <div class="row mx-0">
    @if (hasSolutionTypes || hasWorksWith) {
    <div class="col-12 col-sm-6 ps-0">
      @if (hasSolutionTypes) {
      <div class="mb-6">
        <div class="mb-3 special-padding-left heading__regular--xxxxs">
          {{ prepareSolutionTypesName(false) }}
        </div>
        <ul class="categories-list special-padding-left technical-information">
          @for (item of solutionTypes; track item) {
          <li>
            <div class="body--s">
              {{ item }}
            </div>
          </li>
          }
        </ul>
      </div>
      }
      @if (hasWorksWith) {
      <div class="mb-6">
        <div class="mb-3 special-padding-left heading__regular--xxxxs">
          {{ prepareWorksWithName(false) }}
        </div>
        <ul class="categories-list technical-information special-padding-left">
          @for (item of worksWith; track item) {
          <li>
            <div class="body--s">
              {{ item }}
            </div>
          </li>
          }
        </ul>
      </div>
      }
    </div>
    }
    @if (hasSapCertified || hasCategories) {
    <div class="col-12 col-sm-6 ps-0">
      @if (hasSapCertified) {
      <div class="mb-6">
        <div class="mb-3 special-padding-left heading__regular--xxxxs">
          {{ prepareCertificationName() }}
        </div>
        <div class="d-flex special-padding-left">
          <button (click)="openModal(partnerCertificationTechnicalInfoConfig)" class="btn btn-link p-0">
            @if (sapCertified.image?.url) {
            <cx-media [container]="sapCertified.image" alt="icon_sap_classification"
              class="icon udex-me-8 d-inline"></cx-media>
            }
            <span>{{ sapCertified.value }}</span>
          </button>
          <udex-modal [open]="partnerCertificationTechnicalInfoConfig.isActive"
            (close)="closeModal(partnerCertificationTechnicalInfoConfig)" (open)="centerModal()" class="col-6">
            <div slot="header" class="w-100 d-flex justify-content-between align-items-center">
              <h3 class="heading__regular--s">{{ sapCertified.value }}</h3>
              <udex-control-button icon="decline" size="Large" design="Tertiary" accessible-role="Button"
                (click)="closeModal(partnerCertificationTechnicalInfoConfig)">
              </udex-control-button>
            </div>
            <div class="d-flex justify-content-center udex-mb-20">
              @if (sapCertified.image?.url) {
              <cx-media [container]="sapCertified.image" alt="icon_sap_classification"
                class="certification-modal-classification-icon"></cx-media>
              }
            </div>
            <p class="text-center udex-mb-20">{{ sapCertified.description }}</p>
          </udex-modal>
        </div>
      </div>
      }
      @if (hasCategories) {
      <div>
        <div class="mb-3 special-padding-left heading__regular--xxxxs">
          {{ 'productDetails.category' | cxTranslate }}
        </div>
        <ul class="categories-list special-padding-left technical-information">
          @for (category of currentFilteredCategories; track category.id) {
          <li class="body--s">
            @for (supcategory of category.supcategories; track $index) {
            @if ($index > 0) {
            <span class="text-blue-gray">{{ ' / ' }}</span>
            }
            <udex-link href="javascript:(void)" (click)="displayCategory($event, supcategory.id)"
              (keydown)="displayCategoryByKeyboard($event, supcategory.id)" design="Default" target="_self"
              interactive-area-size="Normal" wrapping-type="Normal" accessible-role="Link" desktop>{{supcategory.name}}
            </udex-link>
            }
            @if (category.supcategories?.length) {
            <span class="d-inline text-blue-gray">{{ ' / ' }}</span>
            }
            <udex-link href="javascript:(void)" (click)="displayCategory($event, category.id)"
              (keydown)="displayCategoryByKeyboard($event, category.id)" design="Default" target="_self"
              interactive-area-size="Normal" wrapping-type="Normal" accessible-role="Link" desktop>{{category.name}}
            </udex-link>
          </li>
          }
        </ul>
      </div>
      }
    </div>
    }
  </div>
  }
</ng-template>
